import { useListCatalogServices } from "@common/hooks/serviceCatalog";

export interface ServiceOption {
  label: string;
  value: string;
}

const useListServicesForAccount = () => {
  let customError: string | null = null;

  const { data, error, isLoading, refetch, isFetching } =
    useListCatalogServices({ page: { number: 1, size: 500 } });

  let services: ServiceOption[] = [];

  if (data?.data) {
    try {
      services = data.data
        .filter((s) => s.id && s.attributes?.name)
        .map((s) => ({
          value: String(s.id),
          label: s.attributes.name,
        }));
    } catch (err) {
      customError =
        err instanceof Error ? err.message : "An unknown error occurred";
    }
  }

  return {
    services,
    servicesLoading: isLoading,
    servicesFetching: isFetching,
    error: error ?? customError,
    refetch,
  };
};

export default useListServicesForAccount;
